import React from 'react';
import get from 'lodash/get';

import { Box, Grid, Typography } from '@mui/material';
import {
  useRecordContext,
} from 'react-admin';
import { Currencies } from '../../../constants/currencies';

type ThresholdValue = {
  global?: number;
  riskBased?: {
    initial: number;
    slider?: number;
    slope?: number;
    thresholds?: {
      [key: string]: number;
    };
    type: string;
  };
};

export const ThresholdField = ({
  source,
  fontSize,
  unit = '',
}: {
  source: string;
  fontSize?: number;
  unit?: string;
}) => {
  const record = useRecordContext();
  if (!record) return null;

  const value = get(record, source, null) as {
    thresholdVariant?: 'currency' | 'common';
    thresholds?: (ThresholdValue & {
      currency?: Currencies;
    })[];
    commonThreshold?: ThresholdValue;
  };

  if (value.commonThreshold) {
    return (
      <Typography fontSize={fontSize}>
        {value.commonThreshold.global ? `Global: ${value.commonThreshold.global}${unit}` : 'Global: Risk-based'}
      </Typography>
    );
  }

  if (value.thresholds && value.thresholds.length > 0) {
    return (
      <Box display="flex" flexWrap="wrap" gap={1}>
        {value.thresholds?.map((threshold) => {
          if (threshold.riskBased) {
            return (
              <Typography fontSize={fontSize} key={threshold.currency}>
                {threshold.currency}
                {': '}
                Risk-based
              </Typography>
            );
          }
          if (threshold.global) {
            return (
              <Typography fontSize={fontSize} key={threshold.currency}>
                {threshold.currency}
                {': '}
                {threshold.global}
                {unit}
              </Typography>
            );
          }
          return null;
        })}
      </Box>
    );
  }

  return <Typography fontSize={fontSize}>-</Typography>;
};

const AmountThreshold = () => {
  const record = useRecordContext();
  if (!record) return null;

  return (
    <Grid
      alignItems="baseline"
      size={{
        xs: 12,
        sm: 6,
        lg: 4,
      }}
    >
      <Box display="flex" flexDirection="row" gap={1} alignItems="baseline">
        <Typography fontWeight="bold" fontSize={10}>
          Upper threshold
        </Typography>
        <ThresholdField
          source="ruleParameters.default"
          fontSize={10}
        />
        <Typography fontWeight="bold" fontSize={10}>
          Lower threshold
        </Typography>
        <ThresholdField
          source="ruleParameters.lowerThreshold"
          fontSize={10}
        />
      </Box>
    </Grid>
  );
};

export default AmountThreshold;
